import { render, staticRenderFns } from "./VeHrKaoqinPersonRecordForm.vue?vue&type=template&id=b7aaf804&scoped=true"
import script from "./VeHrKaoqinPersonRecordForm.vue?vue&type=script&lang=js"
export * from "./VeHrKaoqinPersonRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aaf804",
  null
  
)

export default component.exports